export enum PartnerPlatform {
    PlatformScience = 'platform science',
}
